/**
 * useListenerStatus — pollt GET /listener-status alle 30s.
 *
 * Pattern: identisch zu DashboardPage.tsx (60s-Polling) und Board.tsx (30s-Polling).
 * Cleanup: active-Flag + clearInterval beim Unmount.
 *
 * Phase 5 Plan 02 — ADMIN-07 als Read-Only Listener-Status.
 */
import { useEffect, useState } from 'react';
import { leadsApi } from '../services/leadsApi';
import type { ListenerStatus } from '../types';

export function useListenerStatus(intervalMs: number = 30_000): {
  data: ListenerStatus | null;
  loading: boolean;
  error: string | null;
} {
  const [data, setData] = useState<ListenerStatus | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;

    const doFetch = async () => {
      try {
        const result = await leadsApi.listenerStatus.get();
        if (active) {
          setData(result);
          setError(null);
          setLoading(false);
        }
      } catch (err: any) {
        if (active) {
          setError(err?.message ?? 'Listener-Status konnte nicht geladen werden');
          setLoading(false);
        }
      }
    };

    doFetch(); // initial sofort
    const id = setInterval(doFetch, intervalMs);

    return () => {
      active = false;
      clearInterval(id);
    };
  }, [intervalMs]);

  return { data, loading, error };
}
